export default __webpack_public_path__ + "static/2-fdd827c8028c9e151941a9f8a90512b2.svg";